import { Injectable } from '@angular/core';
import { CommonService } from './common.service';
import { Observable } from 'rxjs';
import { ResponseResult } from '../interfaces';

@Injectable({
  providedIn: 'root'
})

export class ImportService {
  constructor(private commonService: CommonService) { }

  uploadImageFile(model): Observable<ResponseResult> {
    return this.commonService.uploadImageFile(`import/upload-image-file`, model);
  }

  uploadFile(model): Observable<ResponseResult> {
    return this.commonService.uploadFile(`import/upload-rating-file`, model);
  }

  uploadMultiImageFile(model): Observable<ResponseResult> {
    return this.commonService.uploadImageFile(`import/multi-images`, model);
  }
}

